import React, { useState, useEffect } from "react";
import { saveAs } from "file-saver";

const DownloadComponent = ({ fileUrl, fileName, onClose }) => {
  console.log("fileUrl", fileUrl);

  const handleDownload = () => {
    const blob = new Blob([fileUrl], { type: "application/octet-stream" });
    const url = URL.createObjectURL(blob);
    saveAs(url, fileName);
  };

  useEffect(() => {
    handleDownload();
    onClose();
  }, []);

  return <p>Downloading....</p>;
};

export default DownloadComponent;
